import { LAYER_TYPES } from '../layerTypes';

/**
 * Checks if a given variation has any curved text root
 * @param {Variation} variation - The variation to check
 * @returns {Boolean}
 */
const hasCurvedText = ({ roots }) => {
    const textRoots = roots.filter(({ layerType }) => layerType === LAYER_TYPES.TEXT);

    return textRoots.some(({ layers }) => {
        const [textLayer] = layers;
        return !!textLayer.curvatureAngle;
    });
};

export default hasCurvedText;
